import apiClient from "@/axios";

export const getDeveloperLibrary = async (page = 1, sort = 'created_at', order = 'asc', platformId = null, listId = null, searchQuery = null) => {
  const response = await apiClient.post("/user/library/developer/all", {
    page: page,
    sort: sort,
    order: order,
    platformId: platformId,
    listId: listId,
    searchQuery: searchQuery
  });
  return response;
};

export const removeDeveloper = async (developerId) => {
  const response = await apiClient.post(
    "/user/library/developer/remove-developer",
    {
      developerId: developerId,
    }
  );
  return response;
};

export const updateNotification = async (developerId, isNotification) => {
  const response = await apiClient.post(
    "/user/library/developer/update-notification",
    {
      developerId: developerId,
      isNotification: isNotification,
    }
  );
  return response;
};

export const addToLibrary = async (developerId) => {
  const response = await apiClient.post(
    "/user/library/developer/add-developer",
    {
      developerId: developerId,
    }
  );
  return response;
};

export const removeDeveloperFromAll = async (developerId) => {
  const response = await apiClient.post(
    "/user/library/developer/remove-developer-from-all",
    {
      developerId: developerId,
    }
  );
  return response;
};

export const updateNote = async (developerId, note) => {
  const response = await apiClient.post("/user/library/developer/update-note", {
    developerId: developerId,
    note: note,
  });
  return response;
};
